import { __decorate, __metadata } from "tslib";
import '@1inch-community/ui-components/loaders';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../token-item-base';
import { tokenItemBaseHostStyle } from '../token-item-base';
let TokenItemLoaderElement = class TokenItemLoaderElement extends LitElement {
    constructor() {
        super(...arguments);
        this.mobileView = false;
        this.index = 0;
        this.showIconAfter = false;
    }
    static { this.tagName = 'inch-token-item-loader'; }
    static { this.styles = tokenItemBaseHostStyle; }
    render() {
        return html `<inch-token-item-base
      .iconAfterStyle="${this.iconAfterStyle}"
      .showIconAfter="${this.showIconAfter}"
      .index="${this.index}"
      .iconAfterName="${this.iconAfterName}"
      .mobileView="${this.mobileView}"
    ></inch-token-item-base>`;
    }
};
__decorate([
    property({ type: Object, attribute: false }),
    __metadata("design:type", Object)
], TokenItemLoaderElement.prototype, "iconAfterStyle", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemLoaderElement.prototype, "mobileView", void 0);
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Object)
], TokenItemLoaderElement.prototype, "index", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemLoaderElement.prototype, "iconAfterName", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemLoaderElement.prototype, "showIconAfter", void 0);
TokenItemLoaderElement = __decorate([
    customElement(TokenItemLoaderElement.tagName)
], TokenItemLoaderElement);
export { TokenItemLoaderElement };
//# sourceMappingURL=token-item-loader.element.js.map